// The PIS text, shared by the acceptance gate and the read-only copy in the help centre, so the two
// can never drift. Excludes the page title - each caller supplies its own heading.
export const PatientInformationSheetContent = () => (
  <>
    <h2 className="nhsuk-heading-l">ADHD Remote Physical Health Monitoring</h2>

    <h3 className="nhsuk-heading-m">1. Why have I been given this information?</h3>
    <p className="nhsuk-body">
      You are being offered the option to have your physical health monitoring for ADHD medication
      carried out remotely rather than attending a clinic appointment.
    </p>
    <p className="nhsuk-body">
      This pilot aims to provide more choice, flexibility, and to reduce unnecessary clinic visits
      while continuing to meet national clinical standards. Taking part is voluntary.
    </p>

    <h3 className="nhsuk-heading-m">2. Why is physical health monitoring needed?</h3>
    <p className="nhsuk-body">
      People taking ADHD medication require regular physical health monitoring. This usually includes
      checking blood pressure, heart rate, and possible medication side effects.
    </p>

    <h3 className="nhsuk-heading-m">3. What is remote physical health monitoring?</h3>
    <p className="nhsuk-body">
      Remote monitoring allows you to measure your blood pressure and heart rate at home and submit the
      results securely using an NHS-approved digital platform such as Red Star.
    </p>
    <p className="nhsuk-body">During the pilot, measurements are requested once per month.</p>

    <h3 className="nhsuk-heading-m">4. Who can take part?</h3>
    <p className="nhsuk-body">
      You may be suitable if you are 18 or over, able to give consent, stable on ADHD medication, and
      able to use the equipment yourself or with support.
    </p>

    <h3 className="nhsuk-heading-m">5. Do I have to take part?</h3>
    <p className="nhsuk-body">
      No. Participation is completely optional, and you can withdraw at any time without affecting your
      care.
    </p>

    <h3 className="nhsuk-heading-m">6. What equipment will I need?</h3>
    <p className="nhsuk-body">
      You will need to purchase a validated upper-arm blood pressure monitor. These typically cost
      £15–£25.
    </p>
    <p className="nhsuk-body">
      Not all home blood pressure monitors are equally accurate. That's why it's vital to choose a
      device that's been scientifically validated - and reviewed and approved by the British and Irish
      Hypertension Society (BIHS).
    </p>
    <p className="nhsuk-body">
      BIHS approved monitors meet rigorous accuracy standards confirmed following expert review and are
      recommended by the NHS and NICE for use at home. These are the same standards trusted by doctors,
      nurses, and pharmacists. Guidance on suitable monitors is available once you accept these
      conditions.
    </p>

    <h3 className="nhsuk-heading-m">7. What will I be asked to do?</h3>
    <p className="nhsuk-body">
      Once registered, you will be shown how to use the equipment and submit readings. Each month you
      will enter your blood pressure, heart rate, and complete a brief side-effect questionnaire.
    </p>

    <h3 className="nhsuk-heading-m">8. What happens if results are outside normal range?</h3>
    <p className="nhsuk-body">
      If readings fall outside set safety limits, you may be advised to contact your clinical team for
      review.
    </p>

    <h3 className="nhsuk-heading-m">9. How is my information used?</h3>
    <p className="nhsuk-body">
      Your information is securely stored and reviewed by your NHS clinical team and recorded in your
      health record.
    </p>

    <h3 className="nhsuk-heading-m">10. Who can I contact?</h3>
    <p className="nhsuk-body">
      Please contact your ADHD clinical team if you have questions or concerns.
    </p>

    <p className="nhsuk-body">
      <strong>Thank you for taking the time to read this information.</strong>
    </p>
  </>
);
